import { render } from "./vtagsgroup.vue?vue&type=template&id=65b90886&scoped=true"
import script from "./vtagsgroup.vue?vue&type=script&lang=js"
export * from "./vtagsgroup.vue?vue&type=script&lang=js"

import "./vtagsgroup.vue?vue&type=style&index=0&id=65b90886&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b90886"]])

export default __exports__